@use "@fukuri-admins/ui/layout" as *;

.divider {
  margin: 0;
  border: none;
  border-top: 1px solid border('Tertiary');
  width: 100%;
}
